import _ from 'lodash'
import { post } from './nikan-api'
import $store from '../store'
import FormUtility from './form-utility'

class _NikanApp {
  constructor() {
    this.calcAutoHeight = _.debounce(this.calcAutoHeight, 500, { leading: true, trailing: true })
    this.formUtility = FormUtility
  }

  api(url, data, callback) {
    console.warn('DEPRECATED: use post|get of api', url)

    var promise = post(url, data)

    if (callback == null) {
      return promise
    } else {
      promise.then(response => {
        callback(response)
      })
    }
  }

  isEmpty(obj) {
    if ((typeof obj === 'undefined') || (obj === null)) {
      return true
    }

    return false
  }

  isZeroLength(obj) {
    if ((typeof obj === 'undefined') || (obj === null)) {
      return true
    } else if (obj.constructor === Array && obj.length === 0) {
      return true
    } else if (obj.length === 0) {
      return true
    } else if (typeof obj !== 'string' && $(obj).length === 0) {
      return true
    }

    return false
  }

  calcAutoHeight($root) {
    $root = $($root)
    $root.find('.height-to-bottom.height-to-bottom-done:visible').removeClass('height-to-bottom-done')
    $root.find('.height-to-bottom:visible').heightToBottom()
  }

  isObject = (obj) => {
    return Object.prototype.toString.call(obj) === '[object Object]'
  }

  typeChecker(claims) {
    if (typeof (claims) === 'string') {
      return 'string'
    } else if (this.isObject(claims)) {
      return 'object'
    }
    return 'array'
  }

  /**
  * Checks User permission based on given claims
  * @param {Array, String, Object} claims - given claims
  * accessDeniedAnd => Checks user permission from store and if all the given claims where matched return an index greater than -1 so access will be granted
  * accessDeniedOr => Checks user permission from store and if atleast on of the given claims where matched return an not equal to 0 so access will be granted
  * and function returns true or false based on user access
  */

  checkPermission(claims) {

    if (_.isFunction(claims))
      claims = claims()

    if (!claims || claims === '' || claims.length === 0 || (this.isObject(claims)) && Object.keys(claims).length === 0)
      return true

    const hasPermission = $store.getters['appContext/userHasPermission']
    let accessDeniedAnd // accessDenied for and claims
    let accessDeniedOr = false // accessDenied for or claims
    switch (this.typeChecker(claims)) {
      case 'string':
      case 'array':
        claims = Array.isArray(claims) ? claims : [claims]
        accessDeniedAnd = claims.findIndex(claim => hasPermission(claim) === false) > -1 // implement and mechanism
        break

      case 'object':
        let claimsAnd = claims.and || []
        let claimsOr = claims.or || []
        accessDeniedAnd = claimsAnd.findIndex(claim => hasPermission(claim) === false) > -1 // implement and mechanism
        accessDeniedOr = claimsOr.length == 0 ? false : claimsOr.findIndex(claim => hasPermission(claim) === true) == -1 // implement or mechanism
      default:
        break
    }
    return !accessDeniedAnd && !accessDeniedOr
  }

  /**
  * Checks customer commercial Access
  * @param {String, Function} token - given claims
  */

  checkCommercialAccess(token) {
    const hasPermission = $store.getters['appContext/checkCommercialAccess']

    if (_.isFunction(token))
      token = token()

    if (Array.isArray(token))
      return token.some(x => hasPermission(x))

    return hasPermission(token)
  }

  checkCommercialAccessDetailed(token) {
    const hasPermission = $store.getters['appContext/checkCommercialAccessDetailed']
    if (_.isFunction(token))
      token = token()
    return hasPermission(token)
  }

  GetSyncedDateTimeByServer() {
    const differenceInMilliSecond = $store.getters['appContext/getClientDifferenceDateTimeByServer']
    return new Date(Date.now() + differenceInMilliSecond)
  }
}

const NikanApp = {
  install(app, options) {
    const nikan = new _NikanApp()
    app.config.globalProperties.$nikan = nikan
    app.$nikan = nikan
  }
}

export { _NikanApp }
export default NikanApp
